export default "__VITE_ASSET__CAym0kzH__"